module.exports = __webpack_public_path__ + "img/estimated-insurance-required-output.81f8d1f5.png";